/*
 *
 * File: PassengerStartScreen.js
 *
 * Purpose: Passenger start screen in passengers protected area.
 *
 * Author:   Thomas Burgard (Software development)
 * Created:  18.04.2023
 * Modified: 18.04.2023
 *
 * Copyright (c) DrivePartner GmbH 2022
 *
 */

import { React } from "react";
import { useSelector } from "react-redux";
import {
  getUserFromLocalStorage,
  getPassengerDataFromLocalStorage,
} from "../../utils/localStorage";

//--------------------------------------------------------------
//--- CSS styles -----------------------------------------------
//--------------------------------------------------------------

//--- End Css styles -------------------------------------------

//--------------------------------------------------------------
//--- Variable declarations ------------------------------------
//--------------------------------------------------------------
 
//--- End component variable declarations ----------------------

/**
 * Implementation of passenger screen screen component.
 *
 * @param {*} props
 * @returns JSX-HTML-DOM
 */
const PassengerStartScreen = (props) => {
  const userData = props.userData;
  const username = getUserFromLocalStorage();
  const passengerData = getPassengerDataFromLocalStorage();

  //--------------------------------------------------------------
  //-- REDUX -----------------------------------------------------
  //--------------------------------------------------------------   
  const passengerServerData = useSelector((state) => state.passengerReducer);

  //--------------------------------------------------------------
  //--- Returns JSX code for "BookingScreen" ---------------------
  //--------------------------------------------------------------
  return (
    <>
      <h2>Passenger Start screen in protected area!</h2>
    </>
  );
};

export default PassengerStartScreen;